import { BaseClient } from "@jupiter/core";
import { BrowserBackend } from "./backend";
import { BrowserOptions } from "./types/options";
import { Event, EventType } from "@jupiter/types";
import {
  deviceOS,
  deviceVersion,
  getLocationHref,
  userAgent,
} from "@jupiter/utils";
import isNil from "lodash-es/isNil";
import set from "lodash-es/set";
import get from "lodash-es/get";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { VueRouterHandler } from "./integrations";
// import { deviceOS, deviceVersion } from "@jupiter/utils";

export class BrowserClient extends BaseClient<BrowserBackend, BrowserOptions> {
  private _uuid?: string;

  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  public constructor(options: BrowserOptions = {}) {
    super(BrowserBackend, options);
  }

  _prepareEvent(event: Event) {
    const businessName = this._options.businessName;
    const businessChannel = this._options.businessChannel;
    const businessPosition = this._options.businessPosition;
    const businessUrl = getLocationHref();

    set(event, "business", {
      name: businessName,
      channel: businessChannel,
      position: businessPosition,
      url: businessUrl,
    });

    const currentTime = new Date().getTime().toString();

    set(event, "event.time", currentTime);

    if (get(event, "event.type") !== EventType.PV) {
      let currentUrl;
      if (!isNil(this._options.integrations)) {
        this._options.integrations
          .filter((integration) => integration.name === VueRouterHandler.id)
          .forEach((vueRouterHandler: any) => {
            const router = vueRouterHandler.getVueRouter();
            currentUrl = get(router, "history.current.path");
          });
      }
      currentUrl && set(event, "event.data.url", currentUrl);
    }

    const screenResolution = `${Math.floor(
      screen.width * devicePixelRatio
    )}_${Math.floor(screen.height * devicePixelRatio)}`;

    set(event, "device", {
      userAgent: userAgent,
      os: deviceOS,
      version: deviceVersion,
      screen: screenResolution,
    });
    set(event, "sdk", {
      version: __PKG_VERSION__,
    });

    if (isNil(this._options.deviceId)) {
      if (!this._uuid) {
        return FingerprintJS.load()
          .then((fp) => fp.get())
          .then((result) => {
            const { visitorId } = result;
            this._uuid = visitorId;
            set(event, "device.uuid", visitorId);
            return event;
          });
      } else {
        set(event, "device.uuid", this._uuid);
      }
    } else {
      set(event, "device.uuid", this._options.deviceId);
    }

    return Promise.resolve(event);
  }
}
